const prePacksPrefix = "rj-prepack";
const prefixes = {
    event: `${prePacksPrefix}s-event`,
    filter: `${prePacksPrefix}s-filter`,
    filters: `${prePacksPrefix}s-filters`,
    lazyRenderContainer: `${prePacksPrefix}s__lazy-render-container`,
    noBets: `${prePacksPrefix}s-no-bets`,
    prePack: `${prePacksPrefix}`,
    prePacks: `${prePacksPrefix}s`,
    prePackSelection: `${prePacksPrefix}__selection`,
    viewMore: `${prePacksPrefix}s-view-more`,
};
Object.freeze(prefixes);
export function getPrePacksPrefix(component) {
    return prefixes[component];
}
//# sourceMappingURL=GetPrePacksComponentPrefix.js.map